module.exports = Em.Component.extend({
    annualReport: Em.inject.service(),

    isLoading: false,

    /**
     * @returns {boolean}
     */
    canNavigate: function() {
        return this.get('annualReport').canRevisitStep(this.get('previousStep'))
    }.property('previousStep'),

    /**
     * @returns {boolean}
     */
    isDisabled: function() {
        return !this.get('canNavigate') || this.get('isLoading')
    }.property('canNavigate', 'isLoading'),

    /**
     * @returns {AnnualReportStepEnum}
     */
    previousStep: function() {
        return this.get('annualReport').getPreviousStep(this.get('annualReport.activeStep'))
    }.property('annualReport.activeStep'),

    actions: {
        /**
         * @returns {void}
         */
        didNavigateToPreviousStep: function() {
            if (!this.get('canNavigate') || this.get('isLoading')) {
                return
            }

            this.set('isLoading', true)
            this.container.lookup('router:main').transitionTo('annual_report.' + this.get('previousStep'))
        }
    }
})
